<article class="mb-3 p-2 rounded" *ngIf="course.canAccess" (deferLoad)="triggerShowCourse();">
  <ng-container *ngIf="course.renderOnPage">
    <div class="d-none d-md-block">
      <h4>
        <fa-icon *ngIf="cartService.IsItemInCart(course.netforum_course_id)" icon="shopping-cart" class="mr-2"
          title="This course is in your cart"></fa-icon>
        <a routerLink="/course/{{course.alias}}">{{ course.title }}<ng-container *ngIf="course.library=='WMC'"> (WMC)
          </ng-container></a>
        <span class="float-right coursestatus" *ngIf="lmsUserService.IsLoggedIn">Status:
          {{ course.userData.Status }}</span>
      </h4>
      <h5 class="coursesubtitle" *ngIf="course.subtitle">{{ course.subtitle }}</h5>
      <h6 class="mb-3">
        <app-course-author-list [authors]="course.authors" [link]="false" title="Show author biography"></app-course-author-list>
      </h6>
    </div>

    <div class="d-flex flex-md-row flex-column">
      <div class="mr-2 course-thumb flex-shrink-0 mt-2">
        <a routerLink="/course/{{course.alias}}">
          <app-thumbnail-highlight [course]="course"></app-thumbnail-highlight>
          <img [src]="course.thumbnail_image_url" width="300" height="169" alt="Image for course {{ course.title }}" />
        </a>
      </div>
      <div class="d-md-none">
        <h4>
          <a routerLink="/course/{{course.alias}}">{{ course.title }}<ng-container *ngIf="course.library=='WMC'"> (WMC)
            </ng-container></a>
        </h4>
        <h5 class="coursesubtitle">{{ course.subtitle }}</h5>
      </div>
      <div>
        <app-course-tag-bar [course]="course"></app-course-tag-bar>
        <div class="flex-shrink grey-text course-description"
          [innerHTML]="course.preview ? course.preview : course.description"></div>
      </div>
    </div>
  </ng-container>
</article>